import React from "react"
import { User } from "firebase/auth"
import { LiveId, SpaceKey, UserId } from "popopo-msg"
import { firestore } from "../../core"
import { useLiveViewer, createLiveAccessLog, updateLiveAccessLog, leaveLiveViewer } from "popopo-lib-front/firestore-access"
import { Button } from "react-bootstrap"
import { SpinnerRow } from "../SpinnerRow"

export const SpaceLiveAccessLogForm = (props: { firebase: User; spaceKey: SpaceKey; liveId: LiveId }) => {
  const liveViewer = useLiveViewer(firestore, props.spaceKey, props.liveId, UserId(props.firebase.uid))

  const onClick = async () => {
    if (liveViewer === "loading") {
      console.warn(liveViewer)
      return
    }
    const res = liveViewer === null
      ? await createLiveAccessLog(firestore, props.firebase, props.spaceKey, props.liveId)
      : await updateLiveAccessLog(firestore, props.firebase, props.spaceKey, props.liveId)
    console.info(res)
  }

  const onLeave = async () => {
    if (liveViewer === "loading" || liveViewer === null) {
      console.warn("離脱するにはまず視聴を開始してください")
      return
    }
    const res = await leaveLiveViewer(firestore, props.firebase, props.spaceKey, props.liveId)
    console.info("left", res)
  }

  if (liveViewer === "loading") {
    return <SpinnerRow/>
  }

  return (
    <>
      <div>
        Previous: {liveViewer === null ? "None" : <>
        <ul>
          <li>created_at: {liveViewer.created_at ? new Date(liveViewer.created_at.seconds * 1000).toLocaleString() : "loading..."}</li>
          <li>updated_at: {liveViewer.updated_at ? new Date(liveViewer.updated_at.seconds * 1000).toLocaleString() : "loading..."}</li>
          <li>left_at: {liveViewer.left_at ? new Date(liveViewer.left_at.seconds * 1000).toLocaleString() : "null"}</li>
          <li>new_user_live_comment_id: {liveViewer.new_user_live_comment_id}</li>
        </ul>
      </>}
      </div>
      <Button variant="warning" onClick={onClick}>
        Write
      </Button>
      {" "}
      <Button variant="danger" onClick={onLeave} disabled={liveViewer === null}>
        Leave
      </Button>
    </>
  )
}
